import styled from "styled-components"
import {down} from "styled-breakpoints";

export const BreadCrumbsTopNavStyle = styled.div`
    border-bottom: 1px solid #F2F2F2;

    .container {
        --bs-gutter-x: 0;

        nav, .nav {
            margin: auto;
            padding: 24px 0px;

            > .breadcrumb {
                justify-content: start;
                text-align: start;
                margin: 0;

                .breadcrumb-item {
                    --bs-breadcrumb-divider: ">";
                    --bs-breadcrumb-divider-color: #808080;
                    font-weight: 400;
                    font-size: 14px;
                }

                .breadcrumb-item.active {
                    --bs-breadcrumb-item-active-color: var(--color-text-slight-dark);
                    font-weight: 600;
                }
            }
        }

    }

    ${down("md")} {
        display: none;
        visibility: hidden;
    }
`